import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CommonLibModule,
  FusionTransformationService,
  TabulatorService,
  TestTypeValue,
  UserAuth
} from '@nrwl/common-lib';
import { Options } from 'tabulator-tables';
import { ViaviTableComponent, ViaviTabulatorModule } from '@nrwl/viavi-tabulator';
import { CommonMaterialModule } from '@nrwl/common-material';
import { NavigationProvider } from '@nrwl/navigation-abstract';
import { TemplateService } from '@nrwl/test-setup';
import { Subject } from 'rxjs';

@Component({
  selector: 'viavi-template-data',
  standalone: true,
  imports: [CommonModule, ViaviTabulatorModule, CommonLibModule, CommonMaterialModule],
  templateUrl: './template-data.component.html',
  styleUrls: ['./template-data.component.scss']
})
export class TemplateDataComponent implements OnInit, OnChanges {
  @ViewChild(ViaviTableComponent) child: ViaviTableComponent;
  @Input() dataSource: any;
  @Input() columnHeaders: Array<string>;
  @Input() tableId: string;
  @Input() isCheckBoxEnabled: boolean;
  @Input() resetCheckbox: Subject<string[]>;
  @Output() rowActionEmit = new EventEmitter();
  @Output() removeTemplatesEmit = new EventEmitter();
  table: Options;
  hasReadWriteRole: boolean;
  constructor(
    private readonly transformService: FusionTransformationService,
    private readonly tabulatorService: TabulatorService,
    private readonly userAuth: UserAuth,
    private navigator: NavigationProvider,
    private readonly templateService: TemplateService
  ) {}

  ngOnInit(): void {
    this.hasReadWriteRole = this.userAuth.isAuthedFor('READ_WRITE');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataSource && changes.dataSource.currentValue) {
      this.createTableData();
    }
  }

  createTableData(): void {
    this.dataSource = this.transformService.transformData('templates-management', this.dataSource);
    this.updateColumn();
    this.table = this.tabulatorService.commonTableConfiguration();
    this.table.rowHeight = 56;
    this.table.height = window.innerHeight - 195 + 'px';
    this.table.persistenceID = this.tableId;
    this.table.columns = this.dataSource.column;
    this.table.data = this.dataSource.data;
    this.table.initialSort = [{ column: 'name', dir: 'asc' }];
    this.table = Object.assign({}, this.table);
  }

  //eslint-disable-next-line
  onRowActionClick(action: any): void {
    this.templateService.setTemplateId(action.id);
    if (action.action === 'select') {
      this.templateService.closeTemplateDialog();
      const defaultParams = {
        modeType: 'template',
        templateId: action.id
      };
      let pageId = action.rowData.testType.toLowerCase() + '_test';
      switch (action.rowData.testType) {
        case TestTypeValue.SERVICE_CONTINUITY:
          pageId = 'service_test';
          break;
        case TestTypeValue.TWAMP:
          pageId = 'twamp_test';
          break;
        case TestTypeValue.MULTISTEP:
          pageId = 'multistep_test';
          break;
        case TestTypeValue.TWAMP_REFLECTOR:
        case TestTypeValue.TWAMP_LIGHT_REFLECTOR:
          pageId = 'twamp_reflector_test';
          break;
      }
      this.navigator.navigateToTestSetup(pageId, {
        queryParams: {
          defaultParams: JSON.stringify(defaultParams)
        }
      });
    } else {
      this.rowActionEmit.emit(action);
    }
  }
  private updateColumn(): void {
    if (this.columnHeaders.length > 0) {
      this.dataSource.column.forEach(item => {
        if (this.columnHeaders.indexOf(item.tabulatorInfo.id) === -1) {
          item.tabulatorInfo.visible = false;
        }
      });
    }
  }

  get isActionsDisabled(): boolean {
    if (this.getSelectedItemsIds().length === 0) return true;
  }

  private getSelectedItemsIds(): string[] {
    return this.child?.selection?.map(x => x.id) || [];
  }

  // eslint-disable-next-line
  removeTemplates(actionName): any {
    this.removeTemplatesEmit.emit({
      selectedItems: this.getSelectedItemsIds(),
      actionName: actionName
    });
  }
}
